"use client";

import React from "react";
import { Instagram, Linkedin, Facebook, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterNavigation() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="239660" className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-5 w-24 bg-foreground/10 animate-pulse rounded-md" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary hover:underline underline-offset-4 transition-all font-default text-sm">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const businessName = "RXDELIV Healthcare Logistics";
  return <section id="footer" className="bg-white text-foreground pt-16 pb-8 border-t border-border">
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16">
          
          <div className="flex flex-col items-start space-y-6 bg-white">
            <Link to="/" className="inline-block">
              <img src="https://decent-seal.10web.cloud/wp-content/uploads/2026/04/2d32af_5823d5057c70488e80da6a3dd73fec7emv2.png.avif" alt="RXDELIV" className="h-7 w-auto" loading="lazy" />
            </Link>
            <div className="space-y-2 text-muted-foreground font-default text-sm">
              <p className="flex items-start gap-2">
                <MapPin className="size-4 mt-0.5 shrink-0 text-primary opacity-70" />
                <span>
                  Atlanta Metro Area
                  <br />
                  <span className="text-muted-foreground/60 text-xs mt-1 inline-block mr-4">info@gotmeds.io</span>
                  <span className="text-muted-foreground/60 text-xs mt-1 inline-block">678-358-0270</span>
                  <span className="text-muted-foreground/60 text-xs mt-1 block">Serving the Greater Atlanta Medical Community</span>
                </span>
              </p>
            </div>
          </div>

          <div className="flex flex-col space-y-6">
            <h3 className="font-default font-bold text-lg tracking-tight text-foreground">
              Quick Links
            </h3>
            <MenuProvider menu_id="17">
              <FooterNavigation />
            </MenuProvider>
          </div>

          <div className="flex flex-col space-y-6">
            <h3 className="font-default font-bold text-lg tracking-tight text-foreground">
              Patient Support
            </h3>
            <p className="text-muted-foreground font-default text-sm max-w-xs">
              Premium prescription delivery integrated with Atlanta's top medical professionals for secure, swift care.
            </p>
            <div className="flex items-center gap-4 pt-2">
              <Link to="#" className="bg-accent hover:bg-primary/10 p-2.5 rounded-lg transition-colors text-primary" aria-label="Instagram">
                <Instagram className="size-5" />
              </Link>
              <Link to="#" className="bg-accent hover:bg-primary/10 p-2.5 rounded-lg transition-colors text-primary" aria-label="LinkedIn">
                <Linkedin className="size-5" />
              </Link>
              <Link to="#" className="bg-accent hover:bg-primary/10 p-2.5 rounded-lg transition-colors text-primary" aria-label="Facebook">
                <Facebook className="size-5" />
              </Link>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-border flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-mono text-[10px] text-muted-foreground uppercase tracking-widest">© 2026 GOT MEDS&nbsp;Healthcare Logistics is a 501(c)(3) non profit organization.</p>
          <div className="flex items-center gap-6 font-default text-xs text-muted-foreground uppercase tracking-wider">
            <Link to="#" className="hover:text-primary transition-colors">
              Privacy Policy
            </Link>
            <Link to="#" className="hover:text-primary transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </section>;
}